import { render } from "./ReportsModule.vue?vue&type=template&id=084d7228&ts=true"
import script from "./ReportsModule.vue?vue&type=script&lang=ts"
export * from "./ReportsModule.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__